import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Main from './components/subpages/Main.vue'
import Profile from './components/subpages/Profile.vue'
import Gallery from './components/subpages/Gallery.vue'
import NewBooking from './components/subpages/NewBooking.vue'
import Information from './components/subpages/Information.vue'
import CompaniesList from './components/subpages/CompaniesList.vue'
import ConciergeServices from './components/subpages/ConciergeServices.vue'
import HotelAssistance from './components/subpages/HotelAssistance.vue'
import WebexGuide from './views/WebexGuide.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import ProviderList from './views/ProviderList.vue'
import Affilliates from './views/Affilliates'
import ImportantDeadlines from './views/ImportantDeadlines.vue'
import Companies from './views/Companies.vue'
import AuthedCompanies from './views/AuthedCompanies.vue'
import PageNotFound from './views/PageNotFound.vue'
import SchedulePreview from './views/auth/SchedulePreview.vue'
import MySurvey from './views/auth/MySurvey.vue'
import EmailPassword from './views/auth/EmailPassword.vue'
import ResetPassword from './views/auth/ResetPassword.vue'
import Identify from './views/auth/registration/Identify.vue'
import Cancellation from './views/auth/registration/Cancellation.vue'
import ConfirmCancellation from './views/auth/registration/ConfirmCancellation.vue';
import Register from './views/auth/registration/Register.vue'
import Thank from './views/auth/registration/Thank.vue'
import ThankAfterRegistration from './views/auth/registration/ThankAfterRegistration.vue'
import login from './views/auth/login.vue'
import Redirect from './views/auth/Redirect.vue'
import PresenterAvailabilityPage from './views/auth/registration/presenterRegistration/PresenterAvailabilityPage.vue';
import PreferencesList from './components/subpages/PreferencesList.vue';
import RegistrationPage from './components/subpages/Registration.vue';
import SchedulePreviewSubPage from './components/subpages/SchedulePreview.vue';
import Media from './components/subpages/Media.vue';
import BusSchedule from './components/subpages/BusSchedule.vue';
import FeedbackSurvey from './components/subpages/FeedbackSurvey.vue';
import TourBooking from './components/subpages/TourBooking.vue'
import Booking from './components/subpages/Booking.vue'

import store from './store'

Vue.use(Router)

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        redirect: '/user/profile',
        meta: {
            requiresAuth : true
        },
    },
    {
        path: '/user',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth : true
        },
        children: [
            {
                path: 'dashboard',
                component: Main
            },
            {
                path: 'profile',
                component: Profile
            },
            {
                path: 'gallery',
                component: Gallery
            },
            {
                path: 'information',
                component: Information
            },
            {
                path: 'companies',
                component: CompaniesList
            },
            {
                path: 'new-booking',
                component: NewBooking
            },
            {
                path: 'concierge-services',
                component: ConciergeServices
            },
            {
                path: 'hotel-assistance',
                component: HotelAssistance
            },
            {
                path: 'preferences',
                component: PreferencesList
            },
            {
                path: 'registration',
                component: RegistrationPage
            },
            {
                path: 'schedule-preview',
                component: SchedulePreviewSubPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'media',
                component: Media,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'bus-schedule',
                component: BusSchedule,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'feedback-survey',
                component: FeedbackSurvey,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tour-booking',
                component: TourBooking,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'booking',
                component: Booking,
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: '/redirect',
        name: 'redirect',
        component: Redirect
    },
    {
        path: '/companies',
        name: 'Companies',
        component: Companies
    },
    {
        path: '/webex-guide',
        name: 'WebexGuide',
        component: WebexGuide
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component : PrivacyPolicy
    },
    {
        path: '/provider-list',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/affilliates',
        name: 'Affilliates',
        component: Affilliates
    },
    {
        path: '/important-deadlines',
        name: 'ImportantDeadlines',
        component: ImportantDeadlines
    },
    {
        path: '/auth/companies',
        name: 'AuthedCompanies',
        component: AuthedCompanies,
        meta: {
            requiresAuth : true
        }
    },
    {
        path: '/auth/availability',
        name: 'PresenterAvailabilityPage',
        component: PresenterAvailabilityPage
    },
    {
        path: '/auth/registration/identify',
        name: 'Identify',
        component: Identify
    },
    {
        path: '/auth/registration/signup',
        name: 'register',
        component: Register
    },
    {
        path: '/auth/registration/thank',
        name: 'Thank',
        component: Thank
    },
    {
        path: '/auth/registration/after-update-prefs',
        name: 'ThankAfterRegistration',
        component: ThankAfterRegistration
    },
    {
        path: '/auth/login',
        name: 'login',
        component: login,
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/auth/password/email',
        name: 'EmailPassword',
        component: EmailPassword,
    },
    {
        path: '/auth/password/reset',
        name: 'ResetPassword',
        component: ResetPassword,
    },
    {
        path: '/auth/registration/mail/action/cancellation',
        name: 'ConfirmCancellation',
        component: ConfirmCancellation,
        meta:{
            requiresAuth : true
        }
    },
   {
        path: '/auth/registration/mail/action/cancellation-confirmed',
        name: 'Cancellation',
        component: Cancellation,
        meta:{
            requiresAuth : true
        }
    },
    {
        path: '/auth/schedule-preview',
        name: 'SchedulePreview',
        component: SchedulePreview,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/auth/my-survey',
        name: 'MySurvey',
        component: MySurvey,
        meta: {
            requiresAuth: true
        }
    },
    {
      path: '*',
      name: '404Page',
      component: PageNotFound,
    }
  ]
});
const DEFAULT_AUTH = '/auth/registration/signup'

router.beforeEach((to, from, next) => {

  if(to.matched.some(record => record.meta.guestOnly)) {
        if (store.getters.isLoggedIn) {
            window.location.replace(DEFAULT_AUTH)
            return ;
        }
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }

    let path = to.path ;
    if( to.query.cancelation_token )
    {
        path = `${path}?cancelation_token=${to.query.cancelation_token}`;
    }
    next({ name: 'login', query: { redirect: path } })
    return;
  } else {
    next()
  }
});

export default router;
